import React from 'react'
import { Box, FormControl, TextField, MenuItem } from '@mui/material'
import { FormInputLabel } from '@/shared/ui/input'
import { BlockSettingsProps } from './types'

export const KedoChartsSettings: React.FC<BlockSettingsProps> = ({
    kedo,
    state,
    handleChangeSettings,
}) => {
    return (
        <Box sx={{ mt: 2 }}>
            <FormControl fullWidth margin="normal">
                <FormInputLabel>{kedo.t('Chart type')}</FormInputLabel>
                <TextField
                    select
                    size="small"
                    value={state.item.settings.chart_layout || ''}
                    onChange={(e) =>
                        handleChangeSettings('chart_layout', e.target.value)
                    }
                >
                    <MenuItem value="">{kedo.t('Choose an option')}</MenuItem>
                    <MenuItem value="chart">{kedo.t('Chart')}</MenuItem>
                    <MenuItem value="dashboard">{kedo.t('Dashboard')}</MenuItem>
                </TextField>
            </FormControl>
            <FormControl fullWidth margin="normal">
                <FormInputLabel>{kedo.t('Identifier')}</FormInputLabel>
                <TextField
                    size="small"
                    value={state.item.settings.chart_identifier || ''}
                    onChange={(e) =>
                        handleChangeSettings('chart_identifier', e.target.value)
                    }
                />
            </FormControl>
        </Box>
    )
}
